import {
	Breadcrumb,
	Button,
	Card,
	Checkbox,
	Col,
	Divider,
	Form,
	Input,
	Layout,
	message,
	Row,
	Select,
	Spin,
	Switch,
	Typography,
} from "antd";
import React from "react";
import { IoLogoGoogle, IoLogoWhatsapp } from "react-icons/io5";
import ReactInputMask from "react-input-mask";
import { Link, Navigate } from "react-router-dom";
import {
	getToken,
	getType,
	POST_API,
	POST_CATCH,
	titleWeb,
	verifyConfig,
} from "../../../services/api";
// CONTROLLER
import Page403 from "../../Controller/Page403";
import PageLoad from "../../Controller/PageLoad";

class AdminEquipeForm extends React.Component {
	state = {
		_navigate: false,
		_loading: false,
		_screen: true,
		_params: window.location.href.split("/"),
		defaultValue: null,
		doc: false,
		loadPermission: true,
		listPermission: [],
		permissionSelect: [],
		filter: { CREDENTIAL_TYPE_ID: [] },
	};

	back = "/painel/equipe";

	routes = [
		{ title: <Link to={this.back}>Equipe</Link> },
		{ title: this.props.type === "add" ? "Adicionar" : "Editar" },
	];

	componentDidMount = () => {
		titleWeb("Equipe");
		POST_API("/credential_type/search.php", {
			token: getToken(),
			filter: JSON.stringify({ VISIBLE: "'A'" }),
		})
			.then((rs) => rs.json())
			.then((res) => {
				if (res.return) {
					this.setState({ filter: { CREDENTIAL_TYPE_ID: res.data } });
				} else {
					message.warning({ content: res.msg, key: "screen" });
				}
			})
			.catch(() => POST_CATCH());
		POST_API("/permission/page.php", {
			token: getToken(),
			filter: JSON.stringify({ TYPE: getType() }),
		})
			.then((rs) => rs.json())
			.then((res) => {
				if (res.return) {
					this.setState({ listPermission: res.data });
				} else {
					message.warning({ content: res.msg, key: "screen" });
				}
			})
			.catch(POST_CATCH)
			.finally(() => this.setState({ loadPermission: false }));
		if (this.props.type === "add") {
			this.setState({ _screen: false });
		} else if (this.props.type === "edit") {
			this.onView();
		}
	};

	onView = async () => {
		POST_API("/credential_team/search.php", {
			token: getToken(),
			type: "view",
			filter: JSON.stringify({ ID: this.state._params[5] }),
		})
			.then((rs) => rs.json())
			.then((res) => {
				if (res.return) {
					this.setState({
						defaultValue: res.data,
						doc: String(res.data.LOGIN).length > 14,
						permissionSelect: res.sec,
					});
				} else {
					message.warning({ content: res.msg, key: "screen" });
				}
			})
			.catch(() => POST_CATCH())
			.finally(() => this.setState({ _screen: false }));
	};

	onSend = (values) => {
		this.setState({ _loading: true });
		POST_API("/credential_team/save.php", {
			token: getToken(),
			type: this.props.type,
			master: JSON.stringify(values),
			per: this.state.permissionSelect,
		})
			.then((rs) => rs.json())
			.then((res) => {
				if (res.return) {
					message.success({ content: res.msg, key: "screen" });
					this.setState({ _navigate: true });
				} else {
					message.warning({ content: res.msg, key: "screen" });
				}
			})
			.catch(() => POST_CATCH())
			.finally(() => this.setState({ _loading: false }));
	};

	onChangeField = (a, b) => {
		if (a.length > 0) {
			var name = a[0].name[0];
			var value = a[0].value;
			this.setState({
				defaultValue: {
					...this.state.defaultValue,
					[name]: value,
				},
			});
		}
	};

	onChangePermission = (e) => {
		var temp = this.state.permissionSelect;

		var val = e.target.value;

		if (temp.includes(val)) {
			temp.splice(temp.indexOf(val), 1);
		} else {
			temp.push(val);
		}

		this.setState({ permissionSelect: temp });
	};

	onChangePermissionColumn = (type) => {
		this.state.listPermission.map((v) => {
			var temp = this.state.permissionSelect;

			var val = `${v.ID}.${type}`;

			if (temp.includes(val)) {
				temp.splice(temp.indexOf(val), 1);
			} else {
				temp.push(val);
			}

			this.setState({ permissionSelect: temp });
		});
	};

	onChangePermissionLine = (id) => {
		[`${id}.lista`, `${id}.lixeira`, `${id}.form`, `${id}.delete`].map((v) => {
			var temp = this.state.permissionSelect;

			if (temp.includes(v)) {
				temp.splice(temp.indexOf(v), 1);
			} else {
				temp.push(v);
			}

			this.setState({ permissionSelect: temp });
		});
	};

	render = () => {
		if (this.state._navigate) return <Navigate to={this.back} />;
		if (!verifyConfig(`${this.props.per}.${this.props.type}`))
			return <Page403 />;

		return (
			<Layout>
				<Layout.Content className={"admin-container"}>
					<Row align={"middle"} gutter={[8, 8]}>
						<Col span={18}>
							<Breadcrumb items={this.routes} />
						</Col>
						<Col
							span={6}
							style={{ display: "flex", justifyContent: "flex-end" }}
						>
							<Link to={this.back}>
								<Button
									className="sys-btn-primary sys-btn-small"
									shape="round"
									size="small"
									type="primary"
								>
									Voltar
								</Button>
							</Link>
						</Col>
						{this.state._screen ? (
							<PageLoad />
						) : (
							<Col span={24}>
								<Form
									className={"admin-form"}
									initialValues={this.state.defaultValue}
									layout="vertical"
									onFieldsChange={(a, b) => this.onChangeField(a, b)}
									onFinish={this.onSend}
								>
									<Form.Item hidden name="ID">
										<Input />
									</Form.Item>
									<Row gutter={[16, 0]}>
										<Col md={6} xs={24}>
											<Form.Item
												label={this.state.doc ? "CNPJ" : "CPF"}
												name="LOGIN"
												rules={[
													{ required: true, message: "Campo obrigatório*" },
												]}
											>
												<ReactInputMask
													mask={
														this.state.doc
															? "99.999.999/9999-99"
															: "999.999.999-99"
													}
													maskChar={""}
													maxLength={this.state.doc ? 18 : 14}
													placeholder={this.state.doc ? "CNPJ" : "CPF"}
												>
													{(props) => <Input {...props} />}
												</ReactInputMask>
											</Form.Item>
											<Switch
												checkedChildren="CNPJ"
												defaultChecked={this.state.doc}
												onChange={(v) => this.setState({ doc: v })}
												style={{ position: "absolute", right: 13, top: 35 }}
												unCheckedChildren="CPF"
											/>
										</Col>
										<Col md={18} xs={24}>
											<Form.Item
												label="Nome"
												name="NAME"
												rules={[
													{ required: true, message: "Campo obrigatório*" },
												]}
											>
												<Input type="text" />
											</Form.Item>
										</Col>
										<Col md={16} xs={24}>
											<Form.Item
												label="E-mail"
												name="EMAIL"
												rules={[
													{ required: true, message: "Campo obrigatório*" },
												]}
											>
												<Input addonBefore={<IoLogoGoogle />} type="email" />
											</Form.Item>
										</Col>
										<Col md={8} xs={24}>
											<Form.Item
												label="Whatsapp"
												name="WHATSAPP"
												rules={[
													{ required: true, message: "Campo obrigatório*" },
												]}
											>
												<ReactInputMask
													mask={"+55 (99) 99999-9999"}
													maskChar={""}
													maxLength={19}
													value={this.state.defaultValue?.WHATSAPP}
												>
													{(props) => (
														<Input {...props} addonBefore={IoLogoWhatsapp} />
													)}
												</ReactInputMask>
											</Form.Item>
										</Col>
										<Col span={24}>
											<Card size="small">
												<Row gutter={[8, 8]} style={{ paddingBottom: 8 }}>
													<Col span={12} />
													<Col span={3}>
														<center>
															<Button
																onClick={() =>
																	this.onChangePermissionColumn("lista")
																}
																shape="round"
																size="small"
																type="primary"
															>
																Marcar
															</Button>
														</center>
													</Col>
													<Col span={3}>
														<center>
															<Button
																onClick={() =>
																	this.onChangePermissionColumn("lixeira")
																}
																shape="round"
																size="small"
																type="primary"
															>
																Marcar
															</Button>
														</center>
													</Col>
													<Col span={3}>
														<center>
															<Button
																onClick={() =>
																	this.onChangePermissionColumn("form")
																}
																shape="round"
																size="small"
																type="primary"
															>
																Marcar
															</Button>
														</center>
													</Col>
													<Col span={3}>
														<center>
															<Button
																onClick={() =>
																	this.onChangePermissionColumn("delete")
																}
																shape="round"
																size="small"
																type="primary"
															>
																Marcar
															</Button>
														</center>
													</Col>
												</Row>
												<Row gutter={[8, 8]}>
													<Col span={12}>
														<Typography style={{ fontWeight: 700 }}>
															Módulos
														</Typography>
													</Col>
													<Col span={3}>
														<Typography
															style={{ fontWeight: 700, textAlign: "center" }}
														>
															Lista
														</Typography>
													</Col>
													<Col span={3}>
														<Typography
															style={{ fontWeight: 700, textAlign: "center" }}
														>
															Lixeira
														</Typography>
													</Col>
													<Col span={3}>
														<Typography
															style={{ fontWeight: 700, textAlign: "center" }}
														>
															Novo/Editar
														</Typography>
													</Col>
													<Col span={3}>
														<Typography
															style={{ fontWeight: 700, textAlign: "center" }}
														>
															Deletar
														</Typography>
													</Col>
												</Row>
												{this.state.listPermission.map((v, i) => (
													<Row
														gutter={[8, 8]}
														key={i}
														style={{ paddingBottom: 0 }}
													>
														<Col span={24}>
															<Divider style={{ margin: 0, marginTop: 8 }} />
														</Col>
														<Col span={12}>
															<Button
																onClick={() =>
																	this.onChangePermissionLine(v.ID)
																}
																shape="round"
																size="small"
																type="primary"
															>
																{v.NAME}
															</Button>
														</Col>
														<Col span={3}>
															<center>
																<Checkbox
																	checked={
																		this.state.permissionSelect.includes(
																			`${v.ID}.lista`,
																		)
																			? true
																			: false
																	}
																	onChange={this.onChangePermission}
																	value={`${v.ID}.lista`}
																/>
															</center>
														</Col>
														<Col span={3}>
															<center>
																<Checkbox
																	checked={
																		this.state.permissionSelect.includes(
																			`${v.ID}.lixeira`,
																		)
																			? true
																			: false
																	}
																	onChange={this.onChangePermission}
																	value={`${v.ID}.lixeira`}
																/>
															</center>
														</Col>
														<Col span={3}>
															<center>
																<Checkbox
																	checked={
																		this.state.permissionSelect.includes(
																			`${v.ID}.form`,
																		)
																			? true
																			: false
																	}
																	onChange={this.onChangePermission}
																	value={`${v.ID}.form`}
																/>
															</center>
														</Col>
														<Col span={3}>
															<center>
																<Checkbox
																	checked={
																		this.state.permissionSelect.includes(
																			`${v.ID}.delete`,
																		)
																			? true
																			: false
																	}
																	onChange={this.onChangePermission}
																	value={`${v.ID}.delete`}
																/>
															</center>
														</Col>
													</Row>
												))}
											</Card>
										</Col>
										{/* { this.state.listPermission.map((v, i) => (
                                            <Col key={i} xs={24} md={Number(v.COL)}>
                                                <Card hoverable size="small" title={v.NAME}>
                                                    <Row>
                                                        <Col span={24}>
                                                        { this.state.loadPermission ? <Spin size="small"><Checkbox>Selecionar Todos</Checkbox></Spin> : <Checkbox onChange={this.onChangeAll} value={i}>Selecionar Todos</Checkbox> }
                                                        </Col>
                                                        { v.PERMISSION.map((v1, i1) => (
                                                            <Col span={24} key={i1} style={{ display: 'flex', alignItems: 'center', height: 22}}>
                                                                { this.state.loadPermission ? <Spin size="small"><Checkbox>{v1.DESCRIPTION}</Checkbox></Spin> : <Checkbox onChange={this.onChangeField} value={v1.ID} checked={this.state.permissionSelect.includes(v1.ID) ? true : false}>{v1.DESCRIPTION}</Checkbox> }
                                                            </Col>
                                                        )) }
                                                    </Row>
                                                </Card>
                                            </Col>
                                        )) } */}
										<Col md={24} xs={24}>
											<Button
												className="float-right"
												htmlType="submit"
												loading={this.state._loading}
												shape="round"
												type="primary"
											>
												Salvar
											</Button>
										</Col>
									</Row>
								</Form>
							</Col>
						)}
					</Row>
				</Layout.Content>
			</Layout>
		);
	};
}

export default AdminEquipeForm;
